import { useEffect, useState } from 'react'
import InputAHSF from '../../../../Components/InputAHSF'
import './style.css'
import ButtonAHSF from '../../../../Components/ButtonAHSF'
import { AddObjectives, EditObjective, GetObjective } from '../../../../Redux/Reducers/Submitter/Objectives'
import { useDispatch, useSelector } from 'react-redux'
import $ from "jquery";
import Swal from "sweetalert2";

const ObjectivesAdd = (props) => {
    const [Objectives, setObjectives] = useState(null);
    const [ObjectivesValidation, setObjectivesValidation] = useState(null);

    const ObjectivesOne = useSelector((state) => state.ObjectivesReducer.Objectives)
    const dispatch = useDispatch();


    const validation = () => {
        let ValidationStatus = true
        if (Objectives == null) {
            setObjectivesValidation(true)
            ValidationStatus = false
        } else {
            setObjectivesValidation(false)
            ValidationStatus = true
        }
        return ValidationStatus
    }

    const AddObjectives_ = () => {
        if (validation()) {
            dispatch(AddObjectives({
                objectivesName: Objectives,
                applicationInformationId: localStorage.getItem("ApplicationInformationId")
            }))
             Swal.fire({
                          position: "center",
                          icon: "success",
                          title: "تمت الأضافة بنجاح",
                          showConfirmButton: false,
                          timer: 1500,
                          // width: "500px",
                        });
            $(".close-btn").trigger("click");
        }

    }
    const EditObjectives_ = () => {
        if (validation()) {
            dispatch(EditObjective({
                sU_NT_WPB_ObjectivesId: props.WPB_ObjectivesId,
                objectivesName: Objectives,
                applicationInformationId: localStorage.getItem("ApplicationInformationId")
            }))
            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم التعديل بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            $(".close-btn").trigger("click");

        }

    }

    useEffect(() => {
        if (props.ViewData) {
            dispatch(GetObjective({ sU_NT_WPB_ObjectivesId: props.WPB_ObjectivesId }))

        }
    }, [props.WPB_ObjectivesId])



    const HTML = <>

        <InputAHSF
            fieldsName="Objectives"
            show={true}
            disabled={props.shouldDisableFields}
            defaultValue={
                props.ViewData ? ObjectivesOne?.objectivesName : ""
            }
            onChange={(e) => {
                setObjectives(e.target.value);
            }}
            showValidationMessage={ObjectivesValidation}
            validationMessage={"حقل اجباري"}
        />
        {
            props.shouldDisableFields ?
                <>

                </> : <>

                    <div className='ConainerButtonAHSF'>
                        <ButtonAHSF
                            onClick={props.Action == "edit" ? EditObjectives_ : AddObjectives_
                            }
                            text={"حفظ"}
                            show={true}
                        />
                    </div>
                </>
        }

    </>


    return (
        <>

            {
                props.Action == "edit" ? ObjectivesOne?.objectivesName ? <>{HTML}</>:<></> : <>{HTML}</>
            }
        </>
    )
}

export default ObjectivesAdd